export default __webpack_public_path__ + "static/media/discord-black.f2a4c7b4.png";